import ctl from '@netlify/classnames-template-literals';

export const classes = {
  table: ctl(`
    w-full 
    bg-ghost-white 
    rounded-t-md
  `),
};
